import React from 'react';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import { DefaultLayout } from '../../layout/theme-customizer';

const id = window.location.pathname.split('/').pop()
  const defaultLayout = Object.keys(DefaultLayout);
  const layout = id ? id : defaultLayout
  
class Crear extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
       
        tabla: '',
        estado: '',
        icono: '',
        url: '',
        id_modulo: '',
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errores: [] })
    }
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const {tabla, estado,icono,url,id_modulo } = this.state;
        var errores = [];
        
        if (!tabla) { errores.push("error_tabla"); }
        if (!estado) { errores.push("error_estado"); }

        if (!icono) { errores.push("error_icono"); }
        if (!url) { errores.push("error_url"); }
        if (!id_modulo) { errores.push("error_id_modulo"); }

        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        var datosEnviar = {
          
            tabla: tabla,
            estado: estado,
            icono: icono,
            url: url,
            id_modulo: id_modulo
          
        }
        authAxios.post("modulos/registrar", datosEnviar)
            .then((datosRespuesta) => {
                
                var status = datosRespuesta.data.status;
                
                
                if (datosRespuesta.data.Status) {
                    Swal.fire(
                        'modulo!',
                        datosRespuesta.data.msj,
                        'success'
                    )
                    this.props.history.push("/MasterModulos");
                } else {
                    Swal.fire(
                        'modulo!',
                        datosRespuesta.data.msj,
                        'error'
                    )
                }
            })
            .catch()
    }
    componentDidMount() {
        
    }
    render() {
        const { tabla,estado,icono,url,id_modulo} = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                <b>REGISTRAR MODULO</b>
                            </div>
                            <div className="card-body">
                                <form onSubmit={this.enviarDatos}>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className='row g-3'>
                                          
                                             
                                                <div className="col-md-3">
                                                    <label htmlFor="tabla">Nombre de la tabla </label>
                                                    <input  className={((this.verificarError("error_tabla")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="tabla" id="tabla" value={tabla} placeholder="descripcion" aria-describedby="helpId" onChange={this.cambioValor} />
                                                    <small id="helpId" className="invalid-feedback">Digite el Nombre</small>
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="estado">Estado</label>
                                                    <select name="estado"
                                                        id="estado"
                                                        className={((this.verificarError("error_estado")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el Estado</option>
                                                        <option value="0">Activo</option>
                                                        <option value="1">Inactivo</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el Estado</small>
                                                </div>
                                               
                                            </div>

                                            <div className='row g-3'>
                                          
                                             
                                          <div className="col-md-3">
                                              <label htmlFor="icono">Icono </label>
                                              <input  className={((this.verificarError("error_icono")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="icono" id="icono" value={icono} placeholder="descripcion" aria-describedby="helpId" onChange={this.cambioValor} />
                                              <small id="helpId" className="invalid-feedback">Digite el icono</small>
                                          </div>
                                          <div className="col-md-2">
                                              <label htmlFor="url">Url</label>
                                              <input  className={((this.verificarError("error_url")) ? "is-invalid" : "") + " form-control form-control-sm"} type="text" name="url" id="url" value={url} placeholder="descripcion" aria-describedby="helpId" onChange={this.cambioValor} />
                                              <small id="helpId" className="invalid-feedback">Digite la url</small>
                                          </div>
                                         
                                      </div>

                                      <div className="col-md-2">
                                                    <label htmlFor="id_modulo">Id modulo</label>
                                                    <select name="id_modulo"
                                                        id="id_modulo"
                                                        className={((this.verificarError("error_id_modulo")) ? "is-invalid" : "") + " form-select form-select-smselect form-select-sm"}
                                                        onChange={this.cambioValor}>
                                                        <option value="">Seleccione el modulo</option>
                                                        <option value="1">Configuracion</option>
                                                        <option value="2">Otros</option>
                                                    </select>
                                                    <small id="helpId" className="invalid-feedback">Seleccione el modulo</small>
                                                </div>




                                           
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                <button type="submit" className="btn btn-success btn-sm"><FontAwesomeIcon icon={faSave} />&nbsp;&nbsp;Crear modulo</button>&nbsp;&nbsp;
                                                <Link className="btn btn-danger btn-sm" to={`${process.env.PUBLIC_URL}/modulos/lista/${layout}`}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Crear;